import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import {
  OFFLINE_STATUS_SNACKBAR_COLORS,
  OFFLINE_STATUS_TOOLBAR_LABELS,
  STATUS_SNACKBAR_AUTO_HIDE_MS,
} from '../constants/offlineStatusToolbarLabels';

export default function OfflineStatusSnackbar({
  open,
  onClose,
  autoHideDuration = STATUS_SNACKBAR_AUTO_HIDE_MS,
}) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={autoHideDuration}
      id="sc-offline_status_snackbar"
      open={open}
      onClose={onClose}
    >
      <Alert
        icon={false}
        severity="warning"
        variant="outlined"
        sx={{
          alignItems: 'center',
          backgroundColor: OFFLINE_STATUS_SNACKBAR_COLORS.background,
          borderColor: OFFLINE_STATUS_SNACKBAR_COLORS.main,
          color: OFFLINE_STATUS_SNACKBAR_COLORS.main,
          maxWidth: 480,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <WifiOffIcon
            aria-hidden
            sx={{ flexShrink: 0 }}
          />
          <Box>
            <Typography
              component="p"
              sx={{
                fontWeight: 600,
                lineHeight: 1.4,
                m: 0,
              }}
            >
              {OFFLINE_STATUS_TOOLBAR_LABELS.OFFLINE_SNACKBAR_TITLE}
            </Typography>
            <Typography
              component="p"
              sx={{
                fontWeight: 400,
                lineHeight: 1.4,
                m: 0,
                mt: 0.5,
              }}
              variant="body2"
            >
              {OFFLINE_STATUS_TOOLBAR_LABELS.OFFLINE_SNACKBAR_SUBTITLE}
            </Typography>
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
}

OfflineStatusSnackbar.propTypes = {
  autoHideDuration: PropTypes.number,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
